import script from "./CustomerContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerContactModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomerContactModal.vue?vue&type=style&index=0&id=360bd410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360bd410"]])

export default __exports__